<template>
  <v-card>
    <v-card-title>
      Past in Two Weeks
      <v-spacer />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="upcomingDueFees"
      :loading="false"
      class="elevation-1"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.studID }}</td>
        <td>
          <v-chip
            v-for="fee in props.item.fees"
            :key="fee.feeID"
            small
            @click="toAccount(props.item.studID, fee.feeID)"
          >
            {{ fee.type }}
          </v-chip>
        </td>
        <td>
          <v-icon @click="toAccount(props.item.studID)">
            search
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'UpcomingDueFeeList',
  data() {
    return {
      upcomingDueFeesMap: {},
      headers: [
        { text: 'Student ID' },
        { text: 'Fees' },
        { text: 'Actions' },
      ],
    }
  },
  computed: {
    upcomingDueFees() {
      return Object.entries(this.upcomingDueFeesMap)
        .map(([studID, fees]) => ({ studID, fees }))
    },
  },
  created() {
    this.$store.dispatch('fees/getStudentUpcomingDueFees')
      .then((data) => { this.upcomingDueFeesMap = data })
  },
  methods: {
    toAccount(studID, feeID) {
      this.$router.push(`/student-account/${studID}/fee/${feeID}`)
    },
  },
}
</script>

<style>
</style>
